import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonModal,
  IonButtons,
  IonContent,
  IonToolbar,
  IonHeader,
} from '@ionic/vue';
import BookingManager from '@/components/booking/BookingManager.vue';
import { useWorkplace } from '@/composables/workplace';
import { computed } from 'vue';
import { useAuth } from '@/composables/auth';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingDashboard',
  setup(__props) {

const { userState } = useAuth();
const { workplaceState, fetchLatestBookedWorkplaces } = useWorkplace();
const bookingsModal = ref();

const userFirstname = computed(() => {
  return userState.user?.firstName;
});

const bookingForTheDay = computed(() => {
  if (!workplaceState.bookedWorkplaces) {
    return null;
  }

  return workplaceState.bookedWorkplaces.find((workplace: any) => {
    return workplace.bookingDate.split('T')[0] === new Date().toISOString().split('T')[0];
  });
});

const bookingForFollowingDays = computed(() => {
  if (!workplaceState.bookedWorkplaces) {
    return null;
  }

  return workplaceState.bookedWorkplaces.filter((workplace: any) => {
    return new Date(workplace.bookingDate) > new Date();
  });
});

const confirm = async () => {
  await fetchLatestBookedWorkplaces();
  bookingsModal.value.$el.dismiss('confirm');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(bookingForTheDay))
      ? (_openBlock(), _createBlock(_unref(IonCard), {
          key: 0,
          color: "warning"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardSubtitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Today")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bookingForTheDay).workplace.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardContent), null, {
              default: _withCtx(() => [
                _createTextVNode(" Hey " + _toDisplayString(_unref(userFirstname)) + ", have a nice working day!", 1),
                _hoisted_1,
                _createTextVNode("Your workplace "),
                _createElementVNode("strong", null, _toDisplayString(_unref(bookingForTheDay).workplace.name), 1),
                _createTextVNode(" is waiting for you. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_unref(IonCard), { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardSubtitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Today")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode("No Booking Found")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardContent), null, {
              default: _withCtx(() => [
                _createTextVNode(" Hey " + _toDisplayString(_unref(userFirstname)) + ", seems like you don't have a booking for today. You can book a workplace below. ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_unref(IonCard), { color: "transparent" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardSubtitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Up next")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardTitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Your Upcoming Bookings")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(bookingForFollowingDays) && _unref(bookingForFollowingDays).length > 0)
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingForFollowingDays), (booking) => {
                  return (_openBlock(), _createBlock(_unref(IonItem), {
                    lines: "none",
                    key: booking.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", _hoisted_2, _toDisplayString(new Date(booking.bookingDate.split('T')[0]).toLocaleDateString('de-de', { weekday: 'short', month: 'long', day: 'numeric' })), 1),
                          _hoisted_3,
                          _createElementVNode("strong", null, _toDisplayString(booking.workplace.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(IonCardContent), { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(" Seems like you don't have any upcoming bookings. You can book a workplace below. ")
              ]),
              _: 1
            })),
        _createVNode(_unref(IonButton), {
          id: "open-bookings-modal",
          color: "warning",
          fill: "clear"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Manage Bookings")
          ]),
          _: 1
        }),
        _createVNode(_unref(IonModal), {
          ref_key: "bookingsModal",
          ref: bookingsModal,
          trigger: "open-bookings-modal"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonToolbar), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButtons), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonButton), {
                          strong: true,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (confirm())),
                          color: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Done")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonContent), null, {
              default: _withCtx(() => [
                _createVNode(BookingManager)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    })
  ]))
}
}

})